export default ({state}) => state;
